import { render, staticRenderFns } from "./StoreAuthor.vue?vue&type=template&id=c41b724c"
import script from "./StoreAuthor.vue?vue&type=script&lang=js"
export * from "./StoreAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports